import { render } from "./AdminLayout.vue?vue&type=template&id=dbacafa2&scoped=true&ts=true"
import script from "./AdminLayout.vue?vue&type=script&lang=ts"
export * from "./AdminLayout.vue?vue&type=script&lang=ts"

import "./AdminLayout.vue?vue&type=style&index=0&id=dbacafa2&lang=scss&scoped=true"

import exportComponent from "/opt/pptcopilot/app/ppt/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbacafa2"]])

export default __exports__